import {
  IoCheckmarkOutline,
  IoCloseOutline,
  IoEllipsisHorizontalCircleOutline,
} from "react-icons/io5";
import { defineMessage } from "react-intl";
import generateFrontPath from "../libraries/utils/generateFrontPath";

export const PAYMENTS_SORTS_VALUE_CREATE_ASC = "created_asc";
export const PAYMENTS_SORTS_VALUE_CREATE_DESC = "created_desc";

export const PAYMENTS_SORTS = {
  [PAYMENTS_SORTS_VALUE_CREATE_ASC]: {
    value: PAYMENTS_SORTS_VALUE_CREATE_ASC,
    label: defineMessage({ defaultMessage: "Date de création croissante" }),
  },
  [PAYMENTS_SORTS_VALUE_CREATE_DESC]: {
    value: PAYMENTS_SORTS_VALUE_CREATE_DESC,
    label: defineMessage({ defaultMessage: "Date de création décroissante" }),
  },
};

export const PAYMENTS_SORTS_LIST = Object.values(PAYMENTS_SORTS);

// ============================================================================

export const PAYMENTS_TYPES_VALUE_PAYMENT = "payment";
export const PAYMENTS_TYPES_VALUE_REFUND = "refund";

export const PAYMENTS_TYPES = {
  [PAYMENTS_TYPES_VALUE_PAYMENT]: {
    value: PAYMENTS_TYPES_VALUE_PAYMENT,
    label: defineMessage({ defaultMessage: "Paiement" }),
  },
  [PAYMENTS_TYPES_VALUE_REFUND]: {
    value: PAYMENTS_TYPES_VALUE_REFUND,
    label: defineMessage({ defaultMessage: "Remboursement" }),
  },
};

export const PAYMENTS_TYPES_LIST = Object.values(PAYMENTS_TYPES);

// ============================================================================

export const PAYMENTS_STATES_VALUE_PENDING = "pending";
export const PAYMENTS_STATES_VALUE_PAID = "paid";
export const PAYMENTS_STATES_VALUE_CANCELLED = "cancelled";
export const PAYMENTS_STATES_VALUE_FAILED = "failed";

export const PAYMENTS_STATES = {
  [PAYMENTS_STATES_VALUE_PENDING]: {
    value: PAYMENTS_STATES_VALUE_PENDING,
    label: defineMessage({ defaultMessage: "En attente" }),
    colors: ["orange.600", "orange.300"],
    icon: IoEllipsisHorizontalCircleOutline,
  },
  [PAYMENTS_STATES_VALUE_PAID]: {
    value: PAYMENTS_STATES_VALUE_PAID,
    label: defineMessage({ defaultMessage: "Payé" }),
    colors: ["green.600", "green.300"],
    icon: IoCheckmarkOutline,
  },
  [PAYMENTS_STATES_VALUE_CANCELLED]: {
    value: PAYMENTS_STATES_VALUE_CANCELLED,
    label: defineMessage({ defaultMessage: "Annulé" }),
    colors: ["gray.600", "gray.300"],
    icon: IoCloseOutline,
  },
  [PAYMENTS_STATES_VALUE_FAILED]: {
    value: PAYMENTS_STATES_VALUE_FAILED,
    label: defineMessage({ defaultMessage: "Echoué" }),
    colors: ["red.600", "red.300"],
    icon: IoCloseOutline,
  },
};

export const PAYMENTS_STATES_LIST = Object.values(PAYMENTS_STATES);

// ============================================================================

export const PAYMENTS_ADDITIONAL_DATES = [
  {
    key: "paid_at",
    label: defineMessage({ defaultMessage: "Date de paiement" }),
    labelMessage: defineMessage({ defaultMessage: "{date}, {time}" }),
    message: defineMessage({
      defaultMessage: "Payé le {date} à {time}",
    }),
  },
  {
    key: "cancelled_at",
    label: defineMessage({ defaultMessage: "Date d'annulation" }),
    labelMessage: defineMessage({ defaultMessage: "{date}, {time}" }),
    message: defineMessage({
      defaultMessage: "Annulé le {date} à {time}",
    }),
  },
  {
    key: "failed_at",
    label: defineMessage({ defaultMessage: "Date d'échec" }),
    labelMessage: defineMessage({ defaultMessage: "{date}, {time}" }),
    message: defineMessage({
      defaultMessage: "Échoué le {date} à {time}",
    }),
  },
];

// ============================================================================

export const PAYMENTS_METHODS_VALUE_CREDIT_CARD_PAYBOX = "credit_card_paybox";
export const PAYMENTS_METHODS_VALUE_CREDIT_CARD_POS = "credit_card_pos";
export const PAYMENTS_METHODS_VALUE_SEPA = "sepa";
export const PAYMENTS_METHODS_VALUE_CASH = "cash";
export const PAYMENTS_METHODS_VALUE_CHECK = "check";
export const PAYMENTS_METHODS_VALUE_BANK_TRANSFER = "bank_transfer";

/** @type {Object<string, {value: string, src?: string, label: import("react-intl").MessageDescriptor}>} */
export const PAYMENTS_METHODS = {
  [PAYMENTS_METHODS_VALUE_CREDIT_CARD_PAYBOX]: {
    value: PAYMENTS_METHODS_VALUE_CREDIT_CARD_PAYBOX,
    label: defineMessage({ defaultMessage: "Carte bancaire" }),
    src: generateFrontPath({
      id: "internal-assets",
      parameters: { filePath: "payments/credit-card.png" },
      includeBasePath: true,
    }),
  },
  [PAYMENTS_METHODS_VALUE_CREDIT_CARD_POS]: {
    value: PAYMENTS_METHODS_VALUE_CREDIT_CARD_POS,
    label: defineMessage({ defaultMessage: "Terminal Carte bancaire" }),
    src: generateFrontPath({
      id: "internal-assets",
      parameters: { filePath: "payments/credit-card.png" },
      includeBasePath: true,
    }),
  },
  [PAYMENTS_METHODS_VALUE_SEPA]: {
    value: PAYMENTS_METHODS_VALUE_SEPA,
    label: defineMessage({ defaultMessage: "Prélèvement SEPA" }),
    src: generateFrontPath({
      id: "internal-assets",
      parameters: { filePath: "payments/sepa.png" },
      includeBasePath: true,
    }),
  },
  [PAYMENTS_METHODS_VALUE_CASH]: {
    value: PAYMENTS_METHODS_VALUE_CASH,
    label: defineMessage({ defaultMessage: "Espèces" }),
    src: generateFrontPath({
      id: "internal-assets",
      parameters: { filePath: "payments/cash.png" },
      includeBasePath: true,
    }),
  },
  [PAYMENTS_METHODS_VALUE_CHECK]: {
    value: PAYMENTS_METHODS_VALUE_CHECK,
    label: defineMessage({ defaultMessage: "Chèque" }),
    src: generateFrontPath({
      id: "internal-assets",
      parameters: { filePath: "payments/check.png" },
      includeBasePath: true,
    }),
  },
  [PAYMENTS_METHODS_VALUE_BANK_TRANSFER]: {
    value: PAYMENTS_METHODS_VALUE_BANK_TRANSFER,
    label: defineMessage({ defaultMessage: "Virement bancaire" }),
    src: generateFrontPath({
      id: "internal-assets",
      parameters: { filePath: "payments/sepa.png" },
      includeBasePath: true,
    }),
  },
};

export const PAYMENTS_METHODS_LIST = Object.values(PAYMENTS_METHODS);

// ============================================================================
